import script from "./Carteirinha.vue?vue&type=script&setup=true&lang=js"
export * from "./Carteirinha.vue?vue&type=script&setup=true&lang=js"

import "./Carteirinha.vue?vue&type=style&index=0&id=15dedb07&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-15dedb07"]])

export default __exports__